// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhl_sq","PhotoTitleEditForm__cancelBtn":"iy_b bhl_su bhl_st"};